export default "__VITE_ASSET__etw8JxXM__"